import { render, staticRenderFns } from "./wave-monitor.vue?vue&type=template&id=48f21366&scoped=true"
import script from "./wave-monitor.vue?vue&type=script&lang=js"
export * from "./wave-monitor.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=48f21366&prod&scoped=true&lang=css&external"
import style1 from "./wave-monitor.vue?vue&type=style&index=1&id=48f21366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f21366",
  null
  
)

export default component.exports